import { buildImageURL } from '../../helpers';


const isWebp = document.querySelector('html').classList.contains('webpSupport');

export const IMAGES = [
  isWebp ? buildImageURL('/s6-1.webp') : buildImageURL('/s6-1.png'),
  isWebp ? buildImageURL('/s6-2.webp') : buildImageURL('/s6-2.png'),
  isWebp ? buildImageURL('/s6-3.webp') : buildImageURL('/s6-3.png'),
  isWebp ? buildImageURL('/s6-4.webp') : buildImageURL('/s6-4.png'),
  isWebp ? buildImageURL('/s6-5.webp') : buildImageURL('/s6-5.png')
];
